import { WidgetDataSource } from '../../../../../../../models';
import {
  Widget,
  WidgetGroup,
  Comparison,
} from '../../../../../../../providers/bridge-api/dashboard.service';
import { FieldService } from '../../../../../../../providers/storage-api/field.service';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiInsightPayloadParams } from './widget-ai-insights-point-selection.service';
import { WidgetPointSelection } from './widget-point-selection';

export class ScatterPlotPointSelection extends WidgetPointSelection {
  override assemblePayloadFromSelection(
    selectedPoints: any[],
    widget: Widget<WidgetChartOptions>,
    dataSource: WidgetDataSource,
    widgetGroup?: WidgetGroup,
    comparison?: Comparison
  ): AiInsightPayloadParams {
    const payload = super.assemblePayloadFromSelection(
      selectedPoints,
      widget,
      dataSource,
      widgetGroup,
      comparison
    );

    const valueForAxis = (point, axis: 'x' | 'y') => {
      return point[axis];
    };

    for (let pointIdx = 0; pointIdx < selectedPoints.length; pointIdx++) {
      const point = selectedPoints[pointIdx];
      const bucket = payload.buckets[pointIdx];

      bucket.analytic_item_value = point.id;

      if (widget.payload.yAxis === 'sentiment' || widget.payload.xAxis === 'sentiment') {
        const axis = widget.payload.yAxis === 'sentiment' ? 'y' : 'x';
        bucket.sentiment = valueForAxis(point, axis);
        bucket.sentiment_calculation = 'AVG';
      }

      if (
        FieldService.isCustomField(widget.payload.yAxis) ||
        FieldService.isCustomField(widget.payload.xAxis)
      ) {
        const axis = FieldService.isCustomField(widget.payload.yAxis) ? 'y' : 'x';
        payload.scene_params.rating_field = FieldService.getFieldLongName(
          widget.payload[`${axis}Axis`]
        );
        bucket.aggregate_rating_score = valueForAxis(point, axis);
      }
    }

    return payload;
  }

  protected override fillWidgetQueryOptionsForPoint(widgetQueryOptions, point: any) {
    super.fillWidgetQueryOptionsForPoint(widgetQueryOptions, point);

    widgetQueryOptions.pointName = point.id;
    widgetQueryOptions.widgetContextMenu = {
      name: point.id,
    };
  }
}
